import '../bootstrap';

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "ziggy-js";
import * as Sentry from "@sentry/vue";

import NProgress from "nprogress";
import {
    cdn
} from "@/shared/helpers";

import tooltip from "@/shared/directives/tooltip.js";

import { createPinia } from "pinia";
const pinia = createPinia();

// import googleAnalyticsPlugin from "@/shared/plugins/google_analytics";

import { i18nVue  } from 'laravel-vue-i18n'
import { APP_ENV, SENTRY_VUE_DSN } from "@/shared/const";

(async () => {
    createInertiaApp({
        progress: { color: "#15b881" },
        resolve: async (name) => {
            if(name==='Auth/Login' || !name) {
                window.location.href = '/login';
            }
            const page = await resolvePageComponent(
                `./pages/${name}.vue`,
                import.meta.glob("./pages/**/*.vue"),
            );
            return page;
        },
        async setup({ el, App, props, plugin }) {
            Sentry.setUser(null);
            const application = createApp({
                render: () => h(App, props),
            });

            application
                .mixin(Sentry.createTracingMixins({ trackComponents: true }))
                .use(plugin)
                .use(ZiggyVue)
                .use(i18nVue, {
                    resolve: async lang => {
                        const langs = import.meta.glob('../../../lang/*.json');
                        const langPath = `../../../lang/${lang}.json`;
                        
                        const result = await langs[langPath]();
                        return result;
                    }
                });

            if (APP_ENV != "local") {
                Sentry.attachErrorHandler(application, { logErrors: true });
            }

            application.use(pinia);

            application.config.globalProperties.cdn = cdn;
            // Register components globally
            application.directive("tooltip", tooltip);

            //Sentry configuration
            if (APP_ENV != "local") {
                Sentry.init({
                    app: application,
                    dsn: SENTRY_VUE_DSN,
                    // Set tracesSampleRate to 1.0 to capture 100%
                    // of transactions for performance monitoring.
                    // We recommend adjusting this value in production
                    tracesSampleRate: 0.5,
                    environment: APP_ENV,
                    trackComponents: true,
                    logErrors: true,
                });
            }

            // googleAnalytics
            // application.use(googleAnalyticsPlugin, {
            //     ga_client_id: window.ga_client_id,
            //     user: null,
            // });
            

            return application.mount(el);
        },
    });
})();

window.axios.defaults.transformRequest.push(function (data) {
    if (this.url != "/api/v2/track-paywall-event") {
        NProgress.start();
    }
    return data;
});

window.axios.defaults.transformResponse.push(function (data) {
    NProgress.done();
    return data;
});
